import axios from 'axios';

export default async function getViaCep(cep) {
  const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
  return response;
}

// export default getViaCep;
